import { LoaderProvider } from '@/context/Loader';
import { MarketoProvider } from '@/context/Marketo';
import {
  PortalNotificationsProvider,
  PreviewPortalNotificationsProvider,
} from '@/context/Notifications';
import { PageModelsProvider } from '@/context/PageModels';
import { DataLayerLoginLogout } from '@/features/shared';
import React, { PropsWithChildren } from 'react';
import { GlobalStyleProvider } from '../context/content/GlobalStyle/GlobalStyle';
import {
  PortalPrivacyConsentProvider,
  PreviewPortalPrivacyConsentProvider,
} from '../context/PortalPrivacyConsent';

export const PageProviders = ({
  isPreview,
  children,
}: PropsWithChildren<{ isPreview: boolean }>) => (
  <PageModelsProvider>
    <GlobalStyleProvider>
      <MarketoProvider>
        <LoaderProvider>
          {isPreview ? (
            <PreviewPortalPrivacyConsentProvider>
              <PreviewPortalNotificationsProvider>{children}</PreviewPortalNotificationsProvider>
            </PreviewPortalPrivacyConsentProvider>
          ) : (
            <PortalPrivacyConsentProvider>
              <>
                <PortalNotificationsProvider>{children}</PortalNotificationsProvider>
                <DataLayerLoginLogout />
              </>
            </PortalPrivacyConsentProvider>
          )}
        </LoaderProvider>
      </MarketoProvider>
    </GlobalStyleProvider>
  </PageModelsProvider>
);
